<template>
  <div>
    <div>
      <v-tooltip v-if="selectAuditProductDetail.statusOrder === 'open'" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" class="d-inline-flex">
            <v-icon
              v-if="$auth.policies['import-checks:update-product']"
              @click="$refs['check-imei'].openDialog(item)"
              color="primary"
              size="20"
              >mdi-plus</v-icon
            >
          </div>
        </template>
        <span class="white--text text-justify">
          {{ 'Kiểm hàng bằng quét mã' }}
        </span>
      </v-tooltip>
      <v-tooltip v-if="selectAuditProductDetail.statusOrder === 'open'" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" class="d-inline-flex">
            <v-icon
              class="ml-2"
              v-if="$auth.policies['import-checks:update-product']"
              @click="$refs['popup-edit-only'].openDialog(item)"
              color="primary"
              size="20"
              >mdi-pencil</v-icon
            >
          </div>
        </template>
        <span class="white--text text-justify">
          {{ 'Chỉnh sửa thông tin' }}
        </span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" class="d-inline-flex cursor-pointer">
            <v-icon
              @click="$refs['detail-audit-product'].openDialog(item)"
              size="20"
              class="ml-2"
              v-if="$auth.policies['import-checks:update-product']"
              color="primary"
              >mdi-eye</v-icon
            >
          </div>
        </template>
        <span class="white--text text-justify">
          {{ 'Chi tiết sản phẩm' }}
        </span>
      </v-tooltip>
    </div>
    <popupCheckImei ref="check-imei" @onRefresh="() => $refs['popup-edit-code-after-scan'].openDialog()" />
    <PopupUpdateCode
      ref="popup-edit-only"
      @refresh="
        () => {
          initData()
          $emit('refresh')
        }
      "
    />
    <PopupDetailAuditProduct ref="detail-audit-product" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import popupCheckImei from '../../../views/audit-product/popupCheckImei/index.vue'
import PopupDetailAuditProduct from '../../../views/audit-product/PopupDetailAuditProduct.vue'
import PopupUpdateCode from '../../detail-audit-product/PopupUpdateCode.vue'
export default {
  components: { popupCheckImei, PopupUpdateCode, PopupDetailAuditProduct },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      selectAuditProductDetail(state) {
        return state['auditProducts'].item
      }
    })
  }
}
</script>

<style lang="scss" scoped></style>
